export default "__VITE_ASSET__DfYFpWlr__"